module.exports = {"default":{"mailAddress":"mailto:jira@geops.ch"},"jemh":{"deskName":"JEMH Service Desk","announcementConfKey":"8456955","mailAddress":"mailto:trafimage_karten@geops.ch"},"alma":{"deskName":"alma Service Desk","announcementConfKey":"222729839","mailAddress":"mailto:alma_support@geops.ch"},"trafimage":{"deskName":"Trafimage Karten und Bahnhofpläne","announcementConfKey":"1868598","mailAddress":"mailto:sbb_map@geops.ch"},"sbahnm":{"deskName":"S-Bahn München Service Desk","announcementConfKey":"???","mailAddress":"mailto:sbahnm@geops.de"}}


//////////////////
// WEBPACK FOOTER
// ./static/conf.json
// module id = 99
// module chunks = 1